const MonthList = ({selectedmonth}) => {
    const availablemonths = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
    ];

    const insertMonth=(month)=>{
        selectedmonth(month);
    }

    return (
        <div className="listallmonth flex-column2" style={{width:"100%",height:"100%",gap:"5px"}}>
            <button onClick={()=>insertMonth(availablemonths[0])}>{availablemonths[0]}</button>
            <button onClick={()=>insertMonth(availablemonths[1])}>{availablemonths[1]}</button>
            <button onClick={()=>insertMonth(availablemonths[2])}>{availablemonths[2]}</button>
            <button onClick={()=>insertMonth(availablemonths[3])}>{availablemonths[3]}</button>
            <button onClick={()=>insertMonth(availablemonths[4])}>{availablemonths[4]}</button>
            <button onClick={()=>insertMonth(availablemonths[5])}>{availablemonths[5]}</button>
            <button onClick={()=>insertMonth(availablemonths[6])}>{availablemonths[6]}</button>
            <button onClick={()=>insertMonth(availablemonths[7])}>{availablemonths[7]}</button>
            <button onClick={()=>insertMonth(availablemonths[8])}>{availablemonths[8]}</button>
            <button onClick={()=>insertMonth(availablemonths[9])}>{availablemonths[9]}</button>
            <button onClick={()=>insertMonth(availablemonths[10])}>{availablemonths[10]}</button>
            <button onClick={()=>insertMonth(availablemonths[11])}>{availablemonths[11]}</button>
        </div>
      );
}
export default MonthList;